module.exports = __webpack_public_path__ + "media/images/Seal_BlackYellow-c7b4592c1c675a87b040a155ad82ca7c.png";